<ng-container *transloco="let t">
  <!-- Dismiss button -->
  @if (data?.dismissible) {
    <div class="absolute top-0 right-0 pt-4 pr-4 z-10">
      <button mat-icon-button [matDialogClose]>
        <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </div>
  }

  <!-- Header fixo: icon + title + message — fora do mat-dialog-content para não rolar -->
  @let title = data?.title;
  @let message = data?.message;
  @if (data?.icon?.show || title || message) {
    <div class="flex flex-col sm:flex-row sm:items-start px-6 pt-6 pb-4">
      <!-- Icon -->
      @if (data?.icon?.show) {
        <div
          class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full mr-2"
          [ngClass]="{
            'text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600': data?.icon?.color === 'primary',
            'text-accent-600 bg-accent-100 dark:text-accent-50 dark:bg-accent-600': data?.icon?.color === 'accent',
            'text-warn-600 bg-warn-100 dark:text-warn-50 dark:bg-warn-600': data?.icon?.color === 'warn',
            'text-gray-600 bg-gray-100 dark:text-gray-50 dark:bg-gray-600': data?.icon?.color === 'basic',
            'text-blue-600 bg-blue-100 dark:text-blue-50 dark:bg-blue-600': data?.icon?.color === 'info',
            'text-green-500 bg-green-100 dark:text-green-50 dark:bg-green-500': data?.icon?.color === 'success',
            'text-amber-500 bg-amber-100 dark:text-amber-50 dark:bg-amber-500': data?.icon?.color === 'warning',
            'text-red-600 bg-red-100 dark:text-red-50 dark:bg-red-600': data?.icon?.color === 'error',
          }"
        >
          @let iconName = data?.icon?.name;
          @if (iconName) {
            <mat-icon class="text-current" [svgIcon]="iconName"></mat-icon>
          }
        </div>
      }

      <div class="flex flex-col flex-1 items-start sm:mt-0 space-y-1 sm:text-left dark:text-white">
        @if (title) {
          <div
            class="text-3xl font-semibold tracking-tight leading-8 text-primary dark:text-white"
            [innerHTML]="(data?.titleTranslate ? t(title) : title) | capitalize"
          ></div>
        }
        @if (message) {
          <div class="mt-2 text-secondary dark:text-white" [innerHTML]="getSafeHtml(data?.messageTranslate ? t(message) : message)"></div>
        }
      </div>
    </div>
  }

  <!-- Conteúdo rolável -->
  <mat-dialog-content class="overflow-y-scroll" [style.min-height]="data.contentHeight">
    <div class="w-full">
      <ng-content></ng-content>
    </div>
  </mat-dialog-content>

  <!-- Actions -->
  @let actions = data?.actions;
  @if (actions?.confirm?.show || actions?.cancel?.show || actions?.refresh?.show) {
    <mat-dialog-actions
      class="flex items-center justify-between w-full px-6 py-5 bg-gray-50 sm:justify-between dark:bg-black dark:bg-opacity-10"
    >
      <!-- Refresh button aligned to the left -->
      @let refresh = actions?.refresh;
      @if (refresh?.show) {
        <button mat-flat-button [color]="refresh?.color" [disabled]="!submitEnabled()" (click)="handleRefreshClick()">
          {{ (refresh?.labelTranslate ? t(refresh?.label ?? '') : refresh?.label) | titlecase }}
        </button>
      }

      <!-- Slot opcional: conteúdo à esquerda do footer (ex.: resumo/total) -->
      <ng-content select="[dialogFooterStart]"></ng-content>

      <!-- Spacer to push the buttons to the right -->
      <div class="flex-grow"></div>

      <!-- Cancel and Confirm buttons aligned to the right -->
      <ng-container class="flex items-center">
        <!-- Cancel button -->
        @let cancel = actions?.cancel;
        @if (cancel?.show) {
          <button mat-stroked-button data-testid="dialog-base-cancel" [matDialogClose]="false">
            {{ (cancel?.labelTranslate ? t(cancel?.label ?? '') : cancel?.label) | titlecase }}
          </button>
        }

        <!-- Actions buttons -->
        @if (actions?.buttons) {
          @for (actionButton of actions?.buttons || []; track actionButton.label) {
            <button mat-stroked-button [color]="actionButton?.color" (click)="handleActionButtonClick($index)">
              {{ (actionButton?.labelTranslate ? t(actionButton?.label ?? '') : actionButton?.label) | titlecase }}
            </button>
          }
        }

        <!-- Confirm button -->
        @let confirm = actions?.confirm;
        @if (confirm?.show) {
          <button
            mat-flat-button
            [ngClass]="{ 'dark:bg-blue-600': confirm?.color === 'primary' }"
            [color]="confirm?.color"
            data-testid="dialog-base-confirm"
            [disabled]="!submitEnabled()"
            (click)="handleConfirmClick()"
          >
            {{ (confirm?.labelTranslate ? t(confirm?.label ?? '') : confirm?.label) | titlecase }}
          </button>
        }
      </ng-container>
    </mat-dialog-actions>
  }
</ng-container>
